export const getRootsByKey = (state, key) => state.roots?.[key];
